import { render } from "./RecommendedOffers.vue.ts?vue&type=template&id=dab7ba68&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./RecommendedOffers.vue?vue&type=template&id=dab7ba68&scoped=true&ts=true"
import script from "./RecommendedOffers.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./RecommendedOffers.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecommendedOffers.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./RecommendedOffers.vue?vue&type=script&setup=true&lang=ts"

import "./RecommendedOffers.vue.scss?vue&type=style&index=0&id=dab7ba68&lang=scss&scoped=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./RecommendedOffers.vue?vue&type=style&index=0&id=dab7ba68&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dab7ba68"],['__file',"src/apps/merchant3/components/offers/RecommendedOffers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dab7ba68"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dab7ba68', __exports__)) {
    api.reload('dab7ba68', __exports__)
  }
  
  module.hot.accept("./RecommendedOffers.vue.ts?vue&type=template&id=dab7ba68&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./RecommendedOffers.vue?vue&type=template&id=dab7ba68&scoped=true&ts=true", () => {
    api.rerender('dab7ba68', render)
  })

}


export default __exports__